import type { ShippingOptionProps } from './ShippingOptionCard';
import { ShippingOptionCard } from './ShippingOptionCard';

export function ClickAndCollectShippingOptionCard(props: ShippingOptionProps) {
  return (
    <ShippingOptionCard
      {...props}
      selected={props.field.value === props.name}
      onClick={() => {
        props.field.onChange(props.name);
        props.onClick?.();
      }}
      hasError={!!props.fieldState.error}
    />
  );
}
